import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const RichTextEditor = ({ value, onChange, placeholder = "Write your content here..." }) => {
  // Custom toolbar configuration
  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'direction': 'rtl' }],
        [{ 'align': [] }],
        ['blockquote', 'code-block'],
        ['link', 'image', 'video'],
        ['clean']
      ],
    },
    clipboard: {
      matchVisual: false,
    }
  }), []);

  const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'script',
    'list', 'bullet', 'indent',
    'direction', 'align',
    'blockquote', 'code-block',
    'link', 'image', 'video'
  ];

  return (
    <div className="rich-text-editor">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{
          height: '300px',
          marginBottom: '50px'
        }}
      />
      
      {/* Custom CSS for better styling */}
      <style>
        {`
        .rich-text-editor .ql-editor {
          min-height: 250px;
          font-size: 16px;
          line-height: 1.6;
        }
        
        .rich-text-editor .ql-toolbar {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
          border-radius: 8px 8px 0 0;
        }
        
        .rich-text-editor .ql-container {
          border-bottom: 1px solid #ccc;
          border-left: 1px solid #ccc;
          border-right: 1px solid #ccc;
          border-radius: 0 0 8px 8px;
        }
        
        .rich-text-editor .ql-editor.ql-blank::before {
          color: #999;
          font-style: italic;
        }
        
        .rich-text-editor .ql-editor h1 {
          font-size: 2rem;
          margin-bottom: 1rem;
        }
        
        .rich-text-editor .ql-editor h2 {
          font-size: 1.75rem;
          margin-bottom: 0.875rem;
        }
        
        .rich-text-editor .ql-editor h3 {
          font-size: 1.5rem;
          margin-bottom: 0.75rem;
        }
        
        .rich-text-editor .ql-editor p {
          margin-bottom: 1rem;
        }
        
        .rich-text-editor .ql-editor ul, 
        .rich-text-editor .ql-editor ol {
          margin-bottom: 1rem;
          padding-left: 2rem;
        }
        
        .rich-text-editor .ql-editor blockquote {
          border-left: 4px solid var(--primary-color, rgb(128, 0, 128));
          padding-left: 1rem;
          margin: 1rem 0;
          font-style: italic;
          background-color: #f8f9fa;
          padding: 1rem;
          border-radius: 0.25rem;
        }
        
        .rich-text-editor .ql-editor img {
          max-width: 100%;
          height: auto;
          border-radius: 0.5rem;
          margin: 1rem 0;
        }
        
        .rich-text-editor .ql-editor table {
          border-collapse: collapse;
          width: 100%;
          margin: 1rem 0;
        }
        
        .rich-text-editor .ql-editor table td,
        .rich-text-editor .ql-editor table th {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        
        .rich-text-editor .ql-editor table th {
          background-color: #f2f2f2;
          font-weight: bold;
        }
        `}
      </style>
    </div>
  );
};

export default RichTextEditor;